import moment from 'moment'

const MIN_YEAR = 1900
const MAX_YEAR = 2099

/**
 * Progressive DD/MM/YYYY mask: DD/ → MM/ → YYYY
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function sanitizeDdMmYyyyInput(value) {
  if (value == null || value === '') {
    return ''
  }
  if (value instanceof Date && !isNaN(value.getTime())) {
    return moment(value).format('DD/MM/YYYY')
  }

  const digits = String(value).replace(/\D/g, '').slice(0, 8)
  if (!digits.length) {
    return ''
  }

  // --- Day (1–2 digits) ---
  if (digits.length === 1) {
    const n = parseInt(digits[0], 10)
    if (n >= 4) {
      return '0' + n + '/'
    }
    return digits[0]
  }

  let day = digits.slice(0, 2)
  let dayNum = parseInt(day, 10)
  if (dayNum > 31) day = '31'
  else if (dayNum < 1) day = '01'
  else day = day.padStart(2, '0')

  let out = day + '/'
  const afterDay = digits.slice(2)
  if (!afterDay.length) {
    return out
  }

  // --- Month ---
  if (afterDay.length === 1) {
    const m = parseInt(afterDay[0], 10)
    if (m === 0) {
      return out + '0'
    }
    if (m === 1) {
      return out + '1'
    }
    return out + '0' + m + '/'
  }

  let month = afterDay.slice(0, 2)
  let monthNum = parseInt(month, 10)
  if (monthNum > 12) month = '12'
  else if (monthNum < 1) month = '01'
  else month = month.padStart(2, '0')

  out += month
  const afterMonth = afterDay.slice(2)
  if (!afterMonth.length) {
    return out + '/'
  }

  out += '/'

  // --- Year ---
  let year = afterMonth.slice(0, 4)
  if (year.length === 4) {
    const y = parseInt(year, 10)
    if (y < MIN_YEAR) year = String(MIN_YEAR)
    else if (y > MAX_YEAR) year = String(MAX_YEAR)
  }
  out += year

  return out
}

/** @param {string} str */
export function isValidDdMmYyyy(str) {
  return typeof str === 'string' && moment(str, 'DD/MM/YYYY', true).isValid()
}

/**
 * @param {string|null|undefined} value
 * @param {{ onBlur?: boolean }} [options]
 * @returns {string|null} Error message or null if OK / empty
 */
export function getDdMmYyyyValidationError(value, options = {}) {
  if (value == null || String(value).trim() === '') {
    return null
  }
  const s = String(value).trim()
  if (s.length === 10) {
    return isValidDdMmYyyy(s) ? null : 'Invalid date. Use DD/MM/YYYY (e.g. 12/04/2026).'
  }
  if (options.onBlur) {
    return 'Enter a complete date (DD/MM/YYYY).'
  }
  return null
}
